import { Bubble, Props } from './Bubble';
import { useRouter } from '@raysee/hooks';

export const ImageBubble = (props: Props) => {
  const router = useRouter();

  const onClick = () => {
    if (props.message.text.startsWith('遷移_')) {
      props.onSend(props.message.text);
    } else if (props.message.link) {
      router.push(props.message.link);
    } else {
      router.push(props.message.imageUrl);
    }
  };

  return (
    <Bubble {...props}>
      <div className="my-2">
        <a onClick={onClick} className="cursor-pointer">
          <img src={props.message.imageUrl} />
        </a>
      </div>
    </Bubble>
  );
};
